import { render } from "./adminContents.vue?vue&type=template&id=62dd2237&scoped=true"
import script from "./adminContents.vue?vue&type=script&lang=js"
export * from "./adminContents.vue?vue&type=script&lang=js"

import "./adminContents.vue?vue&type=style&index=0&id=62dd2237&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62dd2237"]])

export default __exports__